import React from 'react';
import { motion } from 'framer-motion';
import { Loader } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const LoadingScreen: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="inline-flex items-center justify-center w-16 h-16 rounded-xl bg-gradient-primary mb-6"
        >
          <span className="text-2xl font-bold text-white">N</span>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="flex items-center gap-3 text-gray-600"
        >
          <Loader className="h-5 w-5 animate-spin" />
          <span className="text-lg font-medium">{t('common.loading')}</span>
        </motion.div>
        
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
          className="text-sm text-gray-400 mt-2"
        >
          {t('common.initializing')}
        </motion.p>
      </div>
    </div>
  );
};

export default LoadingScreen;
